import {
  AppSetting,
  AppSettingHistoryResponse,
  AppSettingScopeSchema,
  AppSettingScopesResponse,
} from "../types/appSettings";
import httpService from "./httpService";

class AppSettingsService {
  private readonly baseUrl = "/v3/admin/app-settings";

  async getScopes(): Promise<AppSettingScopesResponse> {
    const response = await httpService.get<AppSettingScopesResponse>(
      `${this.baseUrl}/scopes`
    );
    return response.data;
  }

  async getScopeSchema(scope: string): Promise<AppSettingScopeSchema> {
    const response = await httpService.get<AppSettingScopeSchema>(
      `${this.baseUrl}/scopes/${encodeURIComponent(scope)}/schema`
    );
    return response.data;
  }

  async getSettings(scope: string): Promise<AppSetting> {
    const response = await httpService.get<AppSetting>(
      `${this.baseUrl}/${encodeURIComponent(scope)}`
    );
    return response.data;
  }

  async updateSettings(
    scope: string,
    data: Record<string, unknown>
  ): Promise<AppSetting> {
    const response = await httpService.put<AppSetting>(
      `${this.baseUrl}/${encodeURIComponent(scope)}`,
      data
    );
    return response.data;
  }

  async getHistory(
    scope: string,
    limit = 20
  ): Promise<AppSettingHistoryResponse> {
    const response = await httpService.get<AppSettingHistoryResponse>(
      `${this.baseUrl}/${encodeURIComponent(scope)}/history?limit=${limit}`
    );
    return response.data;
  }
}

export const appSettingsService = new AppSettingsService();
export default appSettingsService;
